import Icon from './Icon';

type Length = number | string;
type ElementSize = [Length, Length];
type FontSize = Length;
type ClassNameIcon=string;
type Href=string;

export type ElementIconElement = {
  icons: {
    base: string
    size: FontSize
    paths: string[]
  },
  icon: ClassNameIcon,
  image: Href,
  size: ElementSize,
  fontSize: FontSize,
}

function ElementIcon({
  element,
  size: propSize,
  fontSize: propFontSize
}: {
  element: ElementIconElement,
  size?: ElementSize,
  fontSize?: FontSize,
}){
  if (!element) return null;
  const { icons, icon, image, size: elSize, fontSize: elFontSize } = element;
  if (icons) {
    const size = propFontSize || elFontSize || icons.size;
    const style = size ? { fontSize: size } : {};

    return (
      <span className={icons.base} style={style}>
        {icons.paths.map((p, idx) => (
          <Icon key={idx} icon={p} />
        ))}
      </span>
    );
  } else if (icon) {
    const size = propFontSize || elFontSize;
    return <Icon icon={icon} fontSize={size} />;
  } else {
    const size = propSize || elSize;
    const style = size
      ? {
          width: size[0],
          height: size[1],
        }
      : {};

    return (
      <img
        // alt={image}
        src={image}
        style={style}
        className="img-responsive"
      />
    );
  }
}

export default ElementIcon;
